import { Box, IconButton, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { setShowSignPopup, setSnackBarAlert } from "../../../../store/one-query/chatsSlice";
import CoinsIcon from "../../../../Custom-imeges/CreditsScenario/CoinsIcon";
import SignInPopup from "../../../landing-page/components/SignInPopup";
import { setMessageErrorAppSuite } from "../../../../store/account/userSlice";
import AvailablePackagesModal from "../../../CreditsScenario/AvailablePackagesModal";
import { useNavigate } from "react-router-dom";
import "../../../ImageSuite/View/ImageSuites.css"

interface AppActionButtonProps {
  appMethodFire: () => void;
  isGenerateButtonDisabled: boolean | undefined;
  IsGeneratePromptLoading?: boolean;
  inputValue: string | File | null;
  creditsCount: number ;
  btnTitle?:string
}
export const AppActionButton = ({
  appMethodFire,
  isGenerateButtonDisabled,
  inputValue,
  IsGeneratePromptLoading,
  creditsCount,
  btnTitle
}: AppActionButtonProps) => {
  const dispatch = useAppDispatch();
  const User = useAppSelector((s) => s.User);
  const appSuiteCosts=useAppSelector((s)=>s.User.AppSuiteCosts)
  const uerCredits = useAppSelector((s) => s.User.UserCredits);
  const MessageErrorAppSuite=useAppSelector((s)=>s?.User?.messageErrorAppSuite)
  const [showPopUpForCreditsFinished,setShowPopUpForCreditsFinished]=useState(false)
  const [showPackageCredits,setShowPackageCredits]=useState(false)
  const [showGif, setShowGif] = useState(true);
  const navigate = useNavigate();
  const CreditValue = window.location.pathname.includes("/image-suit")
    ? appSuiteCosts?.Image
    : window.location.pathname.includes("/video-suit") && appSuiteCosts?.Video;
  const ActionBtnStyle = {
    width: "100%",
    display: "flex",
    alignItems: "center",
    borderRadius: "45.5px",
    textTransform: "unset",
    boxShadow: "none",
    bgcolor: "#12B6EA",
    padding: { md: "8px 24px" },
    color: "#fff",
    transition: "0.3s",
    opacity:
      (typeof inputValue === "string" &&
        inputValue.length > 0 &&
        !isGenerateButtonDisabled) ||
      (inputValue instanceof File && inputValue && !isGenerateButtonDisabled)
        ? "1"
        : "0.5",
    ":hover": {
      bgcolor:  (typeof inputValue === "string" &&
        inputValue.length > 0 &&
        !isGenerateButtonDisabled) ||
      (inputValue instanceof File && inputValue && !isGenerateButtonDisabled)?"#006874":"#12B6EA",
    },
    "&.Mui-disabled": {
      backgroundColor: "#12B6EA",
      color: "#fff",
      cursor: "default",
      Opacity: "0.5",
    },
  };

  const handleBtnActionFire = () => {
    let timer: NodeJS.Timeout;
    if (User.IsAuthenticated) {
      if (!uerCredits) return;
      const availableCredits = uerCredits.credits - uerCredits.usedCredits;
      if (availableCredits < creditsCount) {
        dispatch(
          setSnackBarAlert({
            show: true,
            message: "Not enough credits, Buy more credits",
            alertType: "error",
          })
        );
        return;
      }
      timer = setTimeout(() => {
        setShowGif(false);
      }, 5000);
      appMethodFire();
    } else if (!User.IsAuthenticated) {
      dispatch(
        setShowSignPopup({
          show: true,
          type: "Explore Apps",
          message: "To complete the process you need to Sign in.",
          btnTitle: "Sign In for Free",
          btnAction: "NavigateToLogin",
        })
      );
    }
    return () => clearTimeout(timer);
  };
  useEffect(() => {
    if (MessageErrorAppSuite === "Insufficient credits") {
      setShowPopUpForCreditsFinished(true);
      dispatch(setMessageErrorAppSuite(""));
    }
  }, [MessageErrorAppSuite]);
  const hanldeShowPackageCredits = () => {
    setShowPopUpForCreditsFinished(false);
    if (User.IsAuthenticated && !User?.isSubscribed)
      navigate("/subscription-plans");
    else if (User.IsAuthenticated && User?.isSubscribed)
      setShowPackageCredits(true);
  };
  return (
    <>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {showGif &&
          isGenerateButtonDisabled &&
          (window.location.pathname.includes("/image-suit") ||
            window.location.pathname.includes("/video-suit")) && (
            <Box
              sx={{
                position: "absolute",
                top: "65%",
                margin: "auto",
              }}
            >
              <img
                src="/Images/CreditsScenairo/coins.gif"
                style={{ width: "238px", height: "210.048px" }}
              />
            </Box>
          )}
        <IconButton
          sx={ActionBtnStyle}
          disabled={
            (typeof inputValue === "string" && inputValue.length === 0) ||
            isGenerateButtonDisabled ||
            IsGeneratePromptLoading ||
            (inputValue instanceof File && !inputValue)
          }
          onClick={handleBtnActionFire}
        >
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 500,
              lineHeight: "24px",
            }}
          >
            {btnTitle ? btnTitle : "Generate"}
          </Typography>
          {User.IsAuthenticated && creditsCount > 0 ? (
            <Box
              sx={{
                fontSize: "14px",
                fontWeight: 500,
                lineHeight: "24px",
                display: "flex",
                alignItems: "center",
                marginLeft: "5px",
                whiteSpace: "pre-space",
              }}
            >
              (
              <img src="/Images/CreditsScenairo/fillCoin.svg" />
              <span style={{ margin: "0px 2px" }}>{creditsCount}</span>
              credits)
            </Box>
          ):
          (User.IsAuthenticated && creditsCount === 0 && <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 500,
              lineHeight: "24px",
              marginLeft: "5px",
            }}
          >
            
          </Typography>)
          }
        </IconButton>
      </Box>
      {showPopUpForCreditsFinished && (
        <SignInPopup
          show={showPopUpForCreditsFinished}
          type="Credits"
          handleClose={() => setShowPopUpForCreditsFinished(false)}
          message="Not enough credits, Buy more credits"
          btnTitle="Get more credits"
          Method={hanldeShowPackageCredits}
        />
      )}
      {showPackageCredits && (
        <AvailablePackagesModal
          show={showPackageCredits}
          handleClose={() => setShowPackageCredits(false)}
        />
      )}
    </>
  );
};
